import { createSlice } from "@reduxjs/toolkit";
import { generateQrCodeThunk, getQrCodeThunk, getQRIndividualThunk } from "./qrCodeThunk";

const initialState = {
    status: "idle",
    status1: "idle",
    error: null,
    success: "",
    qrCodes: [],
    qrIndividualData: []
};

const grCodeSlice = createSlice({
    name: "qrCode",
    initialState,
    reducers: {
        resetQrCodeState: (state, action) => {
            state.status = "idle";
            state.error = null;
            state.success = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateQrCodeThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(generateQrCodeThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
            })
            .addCase(generateQrCodeThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "QR Codes are failed";
                state.success = "";
            })


            .addCase(getQrCodeThunk.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getQrCodeThunk.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.qrCodes = action.payload;
            })
            .addCase(getQrCodeThunk.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || "QR Codes are failed";
                state.success = "";
            })


            .addCase(getQRIndividualThunk.pending, (state) => {
                state.status1 = "loading";
                state.error = null;
            })
            .addCase(getQRIndividualThunk.fulfilled, (state, action) => {
                state.status1 = "succeeded";
                state.success = action.payload.success;
                state.error = null;
                state.qrIndividualData = action.payload;
            })
            .addCase(getQRIndividualThunk.rejected, (state, action) => {
                state.status1 = "failed";
                state.error = action.payload || "QR individual data failed";
                state.success = "";
            })
    },
});

export const { resetQrCodeState } = grCodeSlice.actions;
export default grCodeSlice.reducer;